import React from "react";

import globalColors from "../styles/globalColors";

export default (props: { text: any }) => {
  const { text } = props;

  return (
    <div
      style={{
        backgroundColor: globalColors.lightGray,
        color: globalColors.black,
        padding: 15
      }}
    >
      {text}
    </div>
  );
};
